import { render } from "./ModalServicesContentBox.component.vue?vue&type=template&id=56a11122"
import script from "./ModalServicesContentBox.component.vue?vue&type=script&lang=js"
export * from "./ModalServicesContentBox.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/phoneBook/servicesContent/servicesContentComponents/ModalServicesContentBox.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56a11122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56a11122', __exports__)) {
    console.log('reload')
    api.reload('56a11122', __exports__)
  }
  
  module.hot.accept("./ModalServicesContentBox.component.vue?vue&type=template&id=56a11122", () => {
    console.log('re-render')
    api.rerender('56a11122', render)
  })

}


export default __exports__